// Card-Grid block schema - Flexible grid of customizable cards
export const cardGridSchema = {
  type: 'card-grid',
  label: 'Card Grid',
  description: 'Grid of cards for showcasing services, features, or information',
  icon: 'LayoutGrid',
  defaultContent: {
    heading: 'Featured Items',
    headingSize: 'medium', // 'small' | 'medium' | 'large' | 'xlarge'
    items: [
      {
        id: 'card_1',
        title: 'Card Title',
        description: 'Add a description for this card.',
        image: '',
        ctaText: '',
        ctaLink: '',
      },
      {
        id: 'card_2',
        title: 'Card Title',
        description: 'Add a description for this card.',
        image: '',
        ctaText: '',
        ctaLink: '',
      },
      {
        id: 'card_3',
        title: 'Card Title',
        description: 'Add a description for this card.',
        image: '',
        ctaText: '',
        ctaLink: '',
      },
    ],
    columns: 3, // 2 | 3 | 4
    showImages: true,
    style: {},
  },
  fields: [
    { name: 'heading', label: 'Section Heading', type: 'text', placeholder: 'Enter heading...' },
    {
      name: 'headingSize',
      label: 'Heading Size',
      type: 'select',
      options: [
        { value: 'small', label: 'Small' },
        { value: 'medium', label: 'Medium' },
        { value: 'large', label: 'Large' },
        { value: 'xlarge', label: 'Extra Large' },
      ],
    },
    {
      name: 'columns',
      label: 'Columns',
      type: 'select',
      options: [
        { value: 2, label: '2 Columns' },
        { value: 3, label: '3 Columns' },
        { value: 4, label: '4 Columns' },
      ],
    },
    { name: 'showImages', label: 'Show Card Images', type: 'checkbox' },
    { name: 'items', label: 'Cards', type: 'cardList' },
  ],
};

// Helper to generate card ID
export const generateCardId = () => {
  return `card_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};
